export const ADMIN_DASHBOARD_PATH = "/admin/dashboard";

export const INSTITUTION_CATEGORIES_PATH =
  "/admin/setup/institution-categories";

export const STUDENT_CATEGORIES_PATH = "/admin/setup/student-categories";

export const ACCREDITING_BODIES_PATH = "/admin/setup/accrediting-bodies";

export const PROGRAM_LEVELS_PATH = "/admin/setup/program-levels";

export const PARTNER_TYPES_PATH = "/admin/setup/partner-types";

export const PARTNER_PATH = "/admin/partners";

export const SESSIONS_PATH = "/admin/setup";

export const INSTITUTIONS_PATH = "/admin/institutions";

export const STUDENT_STATISTICS_PATH = "/admin/student-statistics";

export const RESEARCH_AREA_PATH = "/admin/setup/research-areas";

export const RESEARCH_CENTRE_PATH = "/admin/research-centres";

export const INSTITUTION_ADMINS_LIST_PATH = "/admin/institution-admins";

export const SUPER_ADMINS_LIST_PATH = "/admin/super-admins";

export const CAMPUS_PATH = "/admin/campuses";

export const ACCREDITATIONS_PATH = "/admin/accreditations";

export const RESEARCH_MAPPING_PATH = "/admin/research-mappings";

export const FACILITY_PATH = "/admin/facilities";

export const AWARD_PATH = "/admin/awards";

export const MILESTONE_PATH = "/admin/awards/milestones";

export const INDUSTRY_COLLABORATION_PATH = "/admin/industry-collaborations";

export const FACULTY_PATH = "/admin/faculties";

export const TECHNOLOGY_INITIATIVE_PATH =
  "/admin/faculties/technology-initiatives";

export const NOTABLE_ALUMNUS_PATH = "/admin/notable-alumni";

export const EVENT_PATH = "/admin/events";

export const AFFILIATION_PATH = "/admin/affiliations";

export const ACADEMIC_PROGRAM_PATH = "/admin/programs";

export const SPECIALISATION_PATH = "/admin/programs/specialisations";

export const PUBLICATION_PATH = "/admin/publications";

export const POSITIONS_PATH = "/admin/setup/positions";

export const STAFF_PATH = "/admin/staff";

export const INSTITUTION_PROFILE_PATH = "/admin/institutions/:id/profile";

export const PUBLICATION_TYPE_PATH = "/admin/publication-types";

export const INSTITUTION_FOCUS_AREA_PATH =
  "/admin/setup/institution-specialisations";

export const TITLE_PATH = "/admin/setup/titles";

export const OWNERSHIP_PATH = "/admin/setup/institution-ownerships";

export const LICENSE_CATEGORIES_PATH = "/admin/setup/licensing-categories";

export const STAFF_STATISTICS_PATH = "/admin/staff-statistics";

export const GRAD_STATISTICS_PATH = "/admin/grad-statistics";

export const INSTITUTION_REPORT_PATH = "/admin/reports";

export const FACILITIES_REPORT_PATH = "/admin/reports/facilities";

export const STUDENTS_REPORT_PATH = "/admin/reports/students";

export const STAFF_REPORT_PATH = "/admin/reports/staff";

export const GRADUATION_REPORT_PATH = "/admin/reports/graduation";

export const PARTNERSHIPS_REPORT_PATH = "/admin/reports/partnerships";

export const ADMIN_PROFILE_PATH = "/admin/profile";

export const AUDIT_TRAIL_PATH = "/admin/audit-trail";
